<script>
  import { router } from '@inertiajs/svelte'
  
  let { user = {}, flash = {} } = $props()
  
  // svelte-ignore state_referenced_locally -- intentional: form field initialized from prop
  let workEmail = $state(user.work_email || '')
  let isResending = $state(false)
  let isUpdating = $state(false)
  let showEmailForm = $state(false)
  
  function resendVerification() {
    isResending = true
    router.post('/verification/resend', {}, {
      onFinish: () => {
        isResending = false
      }
    })
  }
  
  function updateWorkEmail(e) {
    e.preventDefault()
    isUpdating = true
    router.post('/verification/update_email', {
      work_email: workEmail
    }, {
      onFinish: () => {
        isUpdating = false
        showEmailForm = false
      }
    })
  }
</script>

<div class="min-h-screen bg-gray-50 dark:bg-dark-primary flex items-center justify-center px-4 py-10">
  <div class="max-w-md w-full">
    <!-- Logo -->
    <div class="text-center mb-8">
      <a href="/" class="inline-block">
        <h1 class="text-display text-primary mb-2">AX Hub</h1>
      </a>
    </div>
    
    <!-- Verification Card -->
    <div class="card card-bordered p-8 shadow-lg">
      <!-- Flash Messages -->
      {#if flash.alert}
        <div class="mb-6 p-4 bg-error-light dark:bg-error/20 border border-error/30 rounded-xl text-error text-body2">
          {flash.alert}
        </div>
      {/if}
      
      {#if flash.notice}
        <div class="mb-6 p-4 bg-success-light dark:bg-success/20 border border-success/30 rounded-xl text-success-dark dark:text-success text-body2">
          {flash.notice}
        </div>
      {/if}
      
      <!-- Icon -->
      <div class="flex justify-center mb-6">
        <div class="w-20 h-20 bg-primary-50 dark:bg-primary/20 rounded-full flex items-center justify-center">
          <svg class="w-10 h-10 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </div>
      </div>
      
      <h2 class="text-h2 font-semibold text-content text-center mb-2">소속 인증이 필요합니다</h2>
      <p class="text-body2 text-content-secondary text-center mb-6">
        {#if user.work_email}
          <span class="text-primary font-medium">{user.work_email}</span>으로 인증 메일을 발송했습니다.
        {:else}
          커뮤니티 참여를 위해 회사 이메일 인증이 필요합니다.
        {/if}
      </p>
      
      {#if user.work_email && !showEmailForm}
        <!-- Resend Section -->
        <div class="space-y-4">
          <div class="bg-surface-tertiary border border-default rounded-xl p-4 text-body2 text-gray-700 dark:text-dark-text-medium">
            <p class="mb-2 font-medium">📧 메일함을 확인해주세요</p>
            <ul class="list-disc list-inside space-y-1 text-caption text-content-tertiary">
              <li>스팸 폴더도 확인해주세요</li>
              <li>인증 링크는 24시간 동안 유효합니다</li>
            </ul>
          </div>
          
          <button
            onclick={resendVerification}
            disabled={isResending}
            class="btn btn-secondary btn-lg w-full disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {#if isResending}
              <span class="flex items-center justify-center">
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                </svg>
                발송 중...
              </span>
            {:else}
              인증 메일 다시 보내기
            {/if}
          </button>
          
          <button
            onclick={() => showEmailForm = true}
            class="btn btn-ghost btn-lg w-full"
          >
            다른 이메일로 변경하기
          </button>
        </div>
      {:else}
        <!-- Email Form -->
        <form onsubmit={updateWorkEmail} class="space-y-4">
          <div>
            <label for="work_email" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">회사 이메일</label>
            <input
              type="email"
              id="work_email"
              bind:value={workEmail}
              required
              class="input"
              placeholder="you@company.com"
            />
            <p class="mt-2 text-caption text-content-tertiary">
              회사 도메인 이메일을 입력해주세요 (예: @samsung.com, @kakao.com)
            </p>
          </div>
          
          <button
            type="submit"
            disabled={isUpdating || !workEmail}
            class="btn btn-primary btn-lg w-full disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {#if isUpdating}
              <span class="flex items-center justify-center">
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                </svg>
                처리 중...
              </span>
            {:else}
              인증 메일 발송
            {/if}
          </button>
          
          {#if user.work_email}
            <button
              type="button"
              onclick={() => showEmailForm = false}
              class="btn btn-secondary btn-lg w-full"
            >
              취소
            </button>
          {/if}
        </form>
      {/if}
      
      <!-- Skip/Later Option -->
      <div class="mt-6 pt-6 border-t border-default">
        <a
          href="/dashboard"
          class="block text-center text-body2 text-content-tertiary hover:text-primary transition-colors"
        >
          나중에 인증하기 →
        </a>
        <p class="mt-2 text-caption text-gray-400 dark:text-dark-text-disabled text-center">
          일부 기능이 제한될 수 있습니다
        </p>
      </div>
    </div>
    
    <!-- Logout -->
    <p class="mt-6 text-center">
      <a href="/logout" data-method="delete" class="text-gray-500 text-body2 hover:text-gray-700 dark:hover:text-dark-text-low transition-colors">
        다른 계정으로 로그인
      </a>
    </p>
  </div>
</div>
